/**
 * External dependencies.
 */
import { isEmpty, has, assign } from 'lodash';

/**
 * Internal dependencies.
 */
import { getBackgroundStyle, getTextStyle, updateBlock, addStyleTag } from '../../extensions/custom-styles';

function styling( props, selector = false, attributes = false ) {
	const { blockAdvanceOptions } = attributes ? attributes : props.attributes;
	selector = selector ? selector : `.gutenify-section-${ props.clientId } .gutenify-button-link`;

	let css = '';
	css += getBackgroundStyle( blockAdvanceOptions, selector );
	css += getTextStyle( blockAdvanceOptions, selector );

	css += `${ selector }:hover {
		${ has( blockAdvanceOptions, 'hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.hoverTextColor ) ? `color: ${ blockAdvanceOptions.hoverTextColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundColor ) ? `background-color: ${ blockAdvanceOptions.hoverBackgroundColor };` : '' }
		${ has( blockAdvanceOptions, 'hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.hoverBackgroundGradient };` : '' }
		${ has( blockAdvanceOptions, 'hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.hoverBorderColor };` : '' }
	}`;

	const { entranceAnimation = '', entranceAnimationDuration = 'normal', entranceAnimationDelay = '' } = blockAdvanceOptions;

	let animationDuration = '1.25s';

	if ( 'slow' === entranceAnimationDuration ) {
		animationDuration = '2s';
	} else if ( 'fast' === entranceAnimationDuration ) {
		animationDuration = '.75s';
	}

	const animationDelay = entranceAnimationDelay ? entranceAnimationDelay + 'ms' : '0ms';

	css += `${ selector } {
		${ has( blockAdvanceOptions, 'borderColor' ) && ! isEmpty( blockAdvanceOptions.borderColor ) ? `border-color: ${ blockAdvanceOptions.borderColor };` : '' }
		${ blockAdvanceOptions.borderWidth ? `border-width: ${ blockAdvanceOptions.borderWidth }px;` : '' }
		${ blockAdvanceOptions.borderWidth ? `border-style: solid;` : '' }
		${ blockAdvanceOptions.borderRadius ? `border-radius: ${ blockAdvanceOptions.borderRadius };` : '' }
		${ animationDuration ? `animation-duration: ${ animationDuration };` : '' }
		${ animationDelay ? `animation-delay: ${ animationDelay };` : '' }

	}`;
	// ${ entranceAnimation ? `animation-name: ${ blockAdvanceOptions.entranceAnimation };` : '' }

	return css;
}

const updateBlockStyle = ( data, props ) => {
	const attrs = assign( props.attributes, data );
	const css = styling( props, false, attrs );

	updateBlock( data, css, props );

	// Admin.
	const adminCss = styling( props, `#block-${ props.clientId } .gutenify-button-link` );
	addStyleTag( props, adminCss, `gutenify-block-${ props.clientId }-main`, true );
};

export { updateBlockStyle };
export default styling;
